import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Carousel } from "./Carousel";
import { trpc } from "@/utils/trpc";
import { useMutation } from "@tanstack/react-query";

export default function Home() {
	const [email, setEmail] = useState("");
	const [result, setResult] = useState("");
	const [error, setError] = useState(false);
	const [isLoading, setIsLoading] = useState(false);

	const setEmailMutation = useMutation(
		trpc.email.create.mutationOptions({
			onSuccess: (data) => {
				setResult("Thanks! You’ll hear from us soon.")
				setError(false);
				setIsLoading(false);
			},
			onError: (error) => {
				if (error.message === "Email already subscribed") {
					setResult("Already signed up! You’ll hear from us soon.");
					setError(false);
				} else {
					setResult("Failed to add user, Please try again later.");
					setError(true);
				}
				setIsLoading(false);
			},
		}),
	);

	const handleSubmit = (e: React.FormEvent) => {
		e.preventDefault();
		setResult("")
		setError(false);
		if (!email) return;

		setIsLoading(true);

		setEmailMutation.mutate({
			email
		});
	}

	return (
		<div className="h-dvh overflow-y-auto overflow-x-hidden">
			<div className="flex flex-col items-center justify-start px-6 pt-16 pb-20">
				{/* Main content container */}
				<div className="text-center">
					<h1 className="text-4xl sm:text-5xl font-bold tracking-tight mb-4">
						Workspace For Startups

					</h1>
					<p className="text-muted-foreground mb-8 text-lg">
						Ditch enterprise bloatware and ship faster with Tabbed
					</p>

					{/* Email sign-up form */}
					<form
						onSubmit={handleSubmit}
						className="flex flex-col sm:flex-row gap-3 justify-center"
					>
						<Input
							type="email"
							placeholder="Enter your email"
							value={email}
							onChange={(e) => setEmail(e.target.value)}
							className="max-w-sm"
							required
						/>
						<Button type="submit" className="sm:w-auto w-full">
							{isLoading ? "Joining..." : "Join Waitlist"}
						</Button>
					</form>

					{result && result.length > 0 && (
						<p
							className={`text-sm mt-3 animate-in fade-in ${
								error ? "text-rose-700" : "text-emerald-700"
							}`}
						>
							{result}
						</p>
					)}

					<div className="mt-8 mx-auto w-full px-4">
						<div className="mx-auto w-full max-w-6xl">
							<Carousel />
						</div>
					</div>
				</div>

				{/* Optional footer */}
				<footer className="mt-8 text-sm text-muted-foreground">
					© {new Date().getFullYear()} Tabbed
				</footer>
			</div>
		</div>
	)
}
